import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import { baseUrl } from '../Univ.js';

function EqpGrnList() {
  const [pharmviewData, setpharmviewData] = useState([]);

  useEffect(() => {
    fetchpharmviewData();
  }, []);

  function fetchpharmviewData() {
    axios.get(`${baseUrl}add-eqp-grn/`)
      .then(response => {
        const transformedData = response.data.map(item => ({
          ...item,
          supp: item.supp?.name || '', // Extract distributor name
          action: (
            <Link target="_blank" to={`/eqp-grn-invoice/${item.grn_no}/`} className="btn btn-success">
              View
            </Link>
          )
        }));
        setpharmviewData(transformedData);
      })
      .catch(error => {
        console.log(error);
      });
  }

  const columns = [
    { field: 'id', headerName: 'ID', width: 80 },
    { field: 'grn_no', headerName: 'GRN No', width: 140 },
    { field: 'product', headerName: 'Product', width: 290 },
    { field: 'supp', headerName: 'Distributor', width: 220 },
    { field: 'grnamount', headerName: 'Grn Amount', width: 90 },
    { field: 'grn_date', headerName: 'Grn Date', width: 100 },
    { field: 'invamount', headerName: 'Invoice Amount', width: 110 },
    { field: 'inv_date', headerName: 'Invoice Date', width: 100 },
    { field: 'action', headerName: 'Action',
          renderCell: (params) => (
              <Link target="_blank" to={`/eqp-grn-invoice/${params.row.grn_no}/`} className="btn btn-success">
                View
              </Link>
          ),
        width: 80,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        },
  ];

  return (
    <section className="container mt-4">
      <div className="row">
        <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
          <i className="fa-solid fa-list" aria-hidden="true" style={{ color: 'red' }}></i>
          Equipment GRN List
        </h3>
        {pharmviewData.length > 0 ? (
          <div style={{ height: '100%', width: '100%' }} className="mt-4">
            <DataGrid
              sx={{
                boxShadow: 4,
                border: 4,
                borderColor: 'primary.light',
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
              }}
              rows={pharmviewData}
              columns={columns}
              pageSize={10}
              slots={{ toolbar: GridToolbar }}
              autoHeight
              initialState={{
                sorting: {
                  sortModel: [{ field: 'id', sort: 'desc' }],
                },
              }}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </section>
  );
}

export default EqpGrnList;
